module.exports = __webpack_public_path__ + "media/img/logos/2023/horizontal/environment_day-22b9f99c41f5465831e7ed6b09b2ea0d.svg";